import { NO_NAME_EXP } from 'src/constants/experiment'
import { SubPlan } from 'src/constants/subscription/plans'

export const DEFAULT_EXPERIMENT = {
  name: NO_NAME_EXP,
  plan: SubPlan.default
}
